var Handlebars = require("/home/travis/build/JacobFischer/Custom-Deck-Builder/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tabular\">\n	<nav class=\"tabluar-tabs\">\n		<ul>\n		</ul>\n	</nav>\n	<div class=\"tabular-contents\"></div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/gui/tabular/tabular.hbs
// module id = 227
// module chunks = 0